import type { schemaVoiture as Fr } from '../fr/schemaVoiture';

/** « schemaVoiture » in English — typed on the French: a missing sentence does not compile. */
export const schemaVoiture: typeof Fr = {
  avant: 'FRONT',
  arriere: 'Rear',
  constateDepart: (detail: string) => `Noted at check-out — ${detail}`,
  toucherCarrosserie: 'Tap the bodywork to mark damage',
  effacer: 'Clear',
  signe: 'Signed',
};
